import { DragAndDrop, MediaAttached, MediaAttacherDropdown } from './components';
import { useComposeBoxContext } from './composeBoxContext';

export const MediaSystemComponents = () => {
  const { isComposeBoxOpen, isMediaAttacherOpen } = useComposeBoxContext();

  return (
    <>
      <MediaAttached />
      {isMediaAttacherOpen && <MediaAttacherDropdown />}
      {isComposeBoxOpen && <DragAndDrop />}
    </>
  );
};
